import { DateTime } from 'luxon'
import { v4 as uuidv4 } from 'uuid'

import { geologyAjax } from '../ajax/GeologyAjax'
import { store } from '../state/store'
import { GeoRehandleDTO } from '../DTOs/Geology/GeoRehandleDTO'
import { computeShiftId } from './computeShiftId'
import { enqueue } from './queueOps'
import { nextTempId } from './tempId'
import { TripleShift } from '../types/Shift'

function currentShiftId(): number {
  const { selectedDate, selectedShift } = store.getState().shift
  return computeShiftId(selectedDate, selectedShift)
}

export const geoRehandleMutations = {
  async addGeoRehandle(dto: GeoRehandleDTO, date: DateTime, shift: TripleShift) {
    if (navigator.onLine) return geologyAjax.addGeoRehandle(dto, date, shift)
    const tempId = uuidv4()
    const tempGeoRehandleId = await nextTempId()
    await enqueue({
      entity: 'geoRehandle',
      operation: 'create',
      shiftId: currentShiftId(),
      tempId,
      entityId: tempGeoRehandleId,
      data: { ...dto },
    })
    return {
      success: true,
      data: {
        rehandle: new GeoRehandleDTO({ ...dto, geoRehandleId: tempGeoRehandleId }),
        totalLoads: 0,
        totalTonnes: 0,
      },
    }
  },

  async updateGeoRehandle(dto: GeoRehandleDTO) {
    if (navigator.onLine) return geologyAjax.updateGeoRehandle(dto)
    await enqueue({
      entity: 'geoRehandle',
      operation: 'update',
      shiftId: currentShiftId(),
      entityId: dto.geoRehandleId,
      rowVersion: dto.rowVersion,
      data: { ...dto },
    })
    return {
      success: true,
      data: {
        rehandle: dto,
        totalLoads: 0,
        totalTonnes: 0,
      },
    }
  },

  async deleteGeoRehandle(geoRehandleId: number) {
    if (navigator.onLine) return geologyAjax.deleteGeoRehandle(geoRehandleId)
    await enqueue({
      entity: 'geoRehandle',
      operation: 'delete',
      shiftId: currentShiftId(),
      entityId: geoRehandleId,
    })
    return {
      success: true,
      data: {
        rehandle: null,
        totalLoads: 0,
        totalTonnes: 0,
      },
    }
  },
}
